import type { IGpthelpTool, IGpthelpToolGate } from './tool-types';

/**
 * Host tools that ship dark (plan F10, X5): never offered while the config of
 * the store and branch is unknown, so a tool still switched off for this
 * member never shows before `GET assistant/config` answers. Phase 0 shipped
 * it empty; P1 adds its two tools and Step 8 adds its own.
 */
export const CONFIG_GATED_TOOLS: readonly string[] = [
  'menu_getOptionGroups',
  'menu_exportCatalog',
  'store_getSettings',
  'support_handoff',
];

/**
 * The tool `name` is switched off for this member: listed in the config's
 * `disabledTools`, or the config is unknown and the tool ships dark.
 */
export function switchedOff(
  name: string,
  gate: Pick<IGpthelpToolGate, 'assistantDisabledTools'>,
  gatedTools: readonly string[] = CONFIG_GATED_TOOLS
): boolean {
  const disabled = gate.assistantDisabledTools;
  return disabled === null
    ? gatedTools.includes(name)
    : disabled.includes(name);
}

/**
 * The tool is offered for `gate`: its own permission gate holds and no
 * switch turned it off. The tool list and the re-check before every
 * execution both use it.
 */
export function toolOffered(
  tool: Pick<IGpthelpTool, 'definition' | 'isAvailable'>,
  gate: IGpthelpToolGate
): boolean {
  return tool.isAvailable(gate) && !switchedOff(tool.definition.name, gate);
}
